module.exports = __webpack_public_path__ + "img/plug-solid.d0ccee53.svg";